module.exports = __webpack_public_path__ + "static/media/16.88f08b9e.JPG";